<template>
  <div class="">
      <swiper ref="mySwiper" class="sliders" :options="swiperOptions">
        <swiper-slide v-for="offer in offers" :key="offer.id" @click.native="OfferData(offer)">
          <OfferSingleTile :offer="offer"/>
        </swiper-slide>

      </swiper>
    <store-picker />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OfferSingleTile from '../../Collections/OfferSingleTile'
import StorePicker from '@/components/Collections/StorePicker'
import Windowsize from '@/mixins/Windowsize'

export default {
  name: 'OffersSingleSlider',
  props: ['offers'],
  components: { OfferSingleTile, StorePicker },
  mixins: [Windowsize],
  computed: {
    ...mapGetters(['_T',
      'all_brand_website_banners',
      'siteDomain',
      'brandStoreParams',
      'brandStoreRoute']),
  },
  data() {
    return {
      breakpointsRatio: 1199, //in future will add by windows.width
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        loop: true,
        // initialSlide: 0,
        autoplay: true,
        speed: 1000,
        // direction: 'horizontal',
        // grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  methods: {
    OfferData(offer) {
      if (offer.offer_type && offer.offer_type === 'food_category') {
        this.$router.replace({
          name: this.brandStoreRoute('store_page_category'),
          params: {
            ...this.brandStoreParams,
            category_name: offer.offer_value,
          }
        })
      } else {
        // eslint-disable-next-line no-console
        console.log(offer, 'storepicker-id', this.all_brand_website_banners )
        this.$store.commit('SET_SELECTED_BRAND', offer.brand_id)
        this.$store.commit('SET_SELECTED_OFFER', offer)
        this.$store.commit('IS_STORE_BRAND', false)
        //   if(this.brandWiseStores.length ==1) {
        //   this.$router.replace({
        //     name: this.brandStoreRoute('store_page'),
        //     params:
        //       this.brandStoreParams
        //   })
        // }
        // else {
        this.$bvModal.show('storepicker-id')
        // }
      }
    },
  },
}
</script>

<style lang="scss" scoped>


</style>
